import TruCard from '../../TruCard';
import { useNavigate } from "react-router";
import ResourceItem from '../items/ResourceItem';

export default function TBResourceList() {
  const navigate = useNavigate();

  return (
    <TruCard title={'Resources'}>
      <ResourceItem
        icon="money"
        label="Cost Structure"
        actionLink={() => navigate(`/cost-structure`)}
      />
      <ResourceItem
        icon="report"
        label="Focus Scans"
        actionLink={() => navigate(`/focus-scans`)}
      />
      <ResourceItem
        icon="report"
        label="Mini Scans"
        actionLink={() => navigate(`/mini-scans`)}
      />
      <ResourceItem
        icon="video"
        label="Additional Content"
        actionLink={() => navigate(`/content`)}
      />
      <ResourceItem
        icon="video"
        label="Training"
        actionLink={() => navigate(`/training`)}
      />
    </TruCard>
  );
}